import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Advent of Code Day 19 – A Series of Tubes",
  "description": "",
  "published": "2017-12-19T00:00:00.000Z",
  "redirect_from": ["/blog/advent-code-day-19-series-tubes/swizec/7985"],
  "categories": "Front End, python, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "3f_f1T7kaK4",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Advent of Code Day 19 was one of those light, easy challenges. Just hard enough to make you think a little, easy enough to solve in 20 minutes.`}</p>
    <p>{`This could make a great interview question 🤔`}</p>
    <p>{`The gist of the problem is this:`}</p>
    <ul>
      <li parentName="ul">{`you are given an ASCII drawing of a path`}</li>
      <li parentName="ul">{`you have to follow it to the end`}</li>
      <li parentName="ul">{`collect letters as you pass them`}</li>
      <li parentName="ul">{`print them in sequence`}</li>
    </ul>
    <p>{`For a map like this 👇`}</p>
    <pre><code parentName="pre" {...{}}>{`     |
     |  +--+
     A  |  C
 F---|----E|--+
     |  |  |  D
     +B-+  +--+
`}</code></pre>
    <p>{`Your result is `}<inlineCode parentName="p">{`ABCDEF`}</inlineCode>{`.`}</p>
    <p>{`The real map is… bigger. 201x201 characters. Or at least mine was.`}</p>
    <p>{`Far too large to trace with your finger. I mean, you `}<em parentName="p">{`could`}</em>{` if you had the patience of a gnat, but that's why the 2nd part of today's puzzle asks you to count the number of steps.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/12/carbon-2.png",
        "alt": null
      }}></img></p>
    <p>{`Ain't nobody got the patience to count the number of steps by hand.`}</p>
    <p>{`Luckily coding up a solution in Python is pretty simple.`}</p>
    <p>{`You take a current position, `}<inlineCode parentName="p">{`pos`}</inlineCode>{`, that starts at the only `}<inlineCode parentName="p">{`|`}</inlineCode>{` in top row – your entry point. And a vector `}<inlineCode parentName="p">{`(vy, vx)`}</inlineCode>{` pointing downwards, `}<inlineCode parentName="p">{`(1, 0)`}</inlineCode>{`, and you travel through the map.`}</p>
    <p>{`If you encounter a corner, `}<inlineCode parentName="p">{`input[y][x] == '+'`}</inlineCode>{`, you change direction – the movement vector. If so far you were traveling vertically, then you go either left or right depending on which direction has inputs. If you were traveling horizontally, then you switch to vertical.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`        if input[y][x] == "+":
            if vy != 0:
                # go left or right
                if input[y][x-1] == "-" or input[y][x-1] in "ABCDEFGHIJKLMNOPQRSTUVWXYZ":
                    vy = 0
                    vx = -1
                else:
                    vy = 0
                    vx = 1
            else:
                # go up or down
                if input[y-1][x] == "|" or input[y-1][x] in "ABCDEFGHIJKLMNOPQRSTUVWXYZ":
                    vy = -1
                    vx = 0
                else:
                    vy = 1
                    vx = 0
`}</code></pre>
    <p><inlineCode parentName="p">{`vy`}</inlineCode>{` being different than `}<inlineCode parentName="p">{`0`}</inlineCode>{` tells you that you've been moving vertically. If there's something to the left, you go there; otherwise, you go the opposite direction.`}</p>
    <p>{`Same approach for the horizontal change.`}</p>
    <p>{`When you encounter a letter, you add it to the list of letters.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`        elif input[y][x] not in ["-", "|"]:
            letters.append(input[y][x])
`}</code></pre>
    <p>{`In the end, you make sure to update your current position and steps counter.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`        steps += 1
        pos = (y + vy, x + vx)
`}</code></pre>
    <p>{`That applies the movement vector to our position `}<inlineCode parentName="p">{`pos`}</inlineCode>{` and increments the `}<inlineCode parentName="p">{`steps`}</inlineCode>{` counter. Easy 👌`}</p>
    <p>{`When we put it all together and add a loop, the path following implementation looks like this 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`def followpath(input):
    linelen = max(len(line) for line in input.split("\\n"))
    input = [line.ljust(linelen, " ") for line in input.split("\\n") if len(line) > 0]

    pos = (0, input[0].index("|"))
    vx = 0
    vy = 1
    letters = []
    steps = 0

    print linelen, len(input)

    while True:
        y, x = pos

        if y < 0 or y >= len(input) or x < 0 or x >= linelen or input[y][x] == " ":
            return steps, letters

        if input[y][x] == "+":
            if vy != 0:
                # go left or right
                if input[y][x-1] == "-" or input[y][x-1] in "ABCDEFGHIJKLMNOPQRSTUVWXYZ":
                    vy = 0
                    vx = -1
                else:
                    vy = 0
                    vx = 1
            else:
                # go up or down
                if input[y-1][x] == "|" or input[y-1][x] in "ABCDEFGHIJKLMNOPQRSTUVWXYZ":
                    vy = -1
                    vx = 0
                else:
                    vy = 1
                    vx = 0
        elif input[y][x] not in ["-", "|"]:
            letters.append(input[y][x])

        steps += 1
        pos = (y + vy, x + vx)
`}</code></pre>
    <p>{`We prep the input, start an infinite loop, break out of the loop when we fall outside the `}<inlineCode parentName="p">{`input`}</inlineCode>{` field or hit an empty spot (meaning line is over), and use our path-following logic to move around.`}</p>
    <p>{`Eventually, we reach the end of the line and return our result: The number of steps and the sequence of letters encountered.`}</p>
    <p>{`You can see `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/advent-of-code-2017/blob/master/19.py"
      }}>{`everything on Github`}</a>{`.`}</p>
    <p>{`That was fun 🤙`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      